import React from "react";
import {FieldViewSize} from "../../../../const";
// @ts-ignore
import UserIcon from "src/core/gd-components/icons/user/user-icon-deprecated";

export default function FieldUser_InlineValueNotEmpty(props:any) {

    const size = _.get(props, 'size', FieldViewSize.DEFAULT)

    // the same box FieldDropdown_ValueNotEmpty builds - .ui5-field-dropdown-inline-editable sets
    // min-height and padding, which no helper class on the element can win against, so the size
    // is its own modifier
    const classes = Classes("ui5-field-dropdown-inline-editable", props.className, {
        'size-small' : size === FieldViewSize.SMALL
    })

    const labelClasses = Classes(props.configOptions?.labelClassName || "ui5-txt-default")

    return (
        <>
            <div className  = {classes}
                 onClick    = {props.onClick}
            >
                <UserIcon
                    className   = "m-r-8"
                    size        = "22"
                    userId      = {props.option.value}
                />
                <div className={labelClasses}>
                    {props.option.label}
                </div>
            </div>

            {props.children}
        </>
    )
}
